export const DISPENSE_STATUS = Object.freeze({
  PENDING: 'Pending',
  PREPARING: 'Preparing',
  PREPARED: 'Prepared',
  READY_FOR_PICKUP: 'ReadyForPickup',
  DELIVERING: 'Delivering',
  DELIVERED: 'Delivered',
  RETURNED: 'Returned',
  CANCELLED: 'Cancelled',
  NOT_AVAILABLE: 'NotAvailable',
});

export const DISPENSE_STATUS_COLORS = Object.freeze({
  [DISPENSE_STATUS.NOT_AVAILABLE]: 'default',
  [DISPENSE_STATUS.PENDING]: 'warning',
  [DISPENSE_STATUS.PREPARING]: 'warning',
  [DISPENSE_STATUS.PREPARED]: 'primary',
  [DISPENSE_STATUS.READY_FOR_PICKUP]: 'primary',
  [DISPENSE_STATUS.DELIVERING]: 'primary',
  [DISPENSE_STATUS.DELIVERED]: 'success',
  [DISPENSE_STATUS.RETURNED]: 'danger',
  [DISPENSE_STATUS.CANCELLED]: 'danger',
});